// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__134Ql","modalForm":"UpgradeEpcsModal_modalForm__1MUoy","modalFooter":"UpgradeEpcsModal_modalFooter__1gpVG"};